var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('YA_Snackbar',{ref:"YA_SnackbarRef"}),_c('YA_leftNavBar'),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }